var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHamberMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icHamberMenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RHP-Mobile-Header-Menu",
    transform: "translate(-10.000000, -42.000000)",
    fill: "#575858",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(10.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,1 L24,3 C24,3.6 23.6,4 23,4 L1,4 C0.4,4 0,3.6 0,3 L0,1 C0,0.4 0.4,0 1,0 L23,0 C23.6,0 24,0.4 24,1 Z M24,9 L24,11 C24,11.6 23.6,12 23,12 L1,12 C0.4,12 0,11.6 0,11 L0,9 C0,8.4 0.4,8 1,8 L23,8 C23.6,8 24,8.4 24,9 Z M24,17 L24,19 C24,19.6 23.6,20 23,20 L1,20 C0.4,20 0,19.6 0,19 L0,17 C0,16.4 0.4,16 1,16 L23,16 C23.6,16 24,16.4 24,17 Z",
    id: "icHamberMenu"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHamberMenu);
export default __webpack_public_path__ + "static/media/icHamberMenu.4151affbf9ad48d355d1f3aa0d871ce1.svg";
export { ForwardRef as ReactComponent };